import React, { ReactNode, useLayoutEffect, useRef } from 'react';
import { BdsSidebar, BdsThemeProvider } from '@/core/constants/webComponents';
import './MenuSidebar.scss';

interface MenuSidebarProps {
  logoSlot?: ReactNode;
  searchSelectorSlot: ReactNode;
  dataCollectedSlot: ReactNode;
  menuSlot: ReactNode;
}

export const MenuSidebar: React.FC<MenuSidebarProps> = ({
  logoSlot,
  searchSelectorSlot,
  dataCollectedSlot,
  menuSlot,
}) => {
  const sidebarRef = useRef<HTMLElement | null>(null);

  const headerWidth = 224;

  useLayoutEffect(() => {
    const injectSidebarOverflow = () => {
      const sidebar = sidebarRef.current;
      if (sidebar?.shadowRoot && !sidebar.shadowRoot.querySelector('#sidebar-overflow-fix')) {
        const style = document.createElement('style');
        style.id = 'sidebar-overflow-fix';
        style.innerHTML = `
          .sidebar { overflow: visible !important; }
          .container { overflow: visible !important; }
        `;
        sidebar.shadowRoot.appendChild(style);
      }
    };

    injectSidebarOverflow();
    const interval = setInterval(injectSidebarOverflow, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="menu-sidebar" style={{ width: '240px' }}>
      <BdsThemeProvider theme="dark">
        <BdsSidebar 
          ref={sidebarRef}
          type="fixed" 
          is-open={true} 
          width="240" 
          sidebar-position="left" 
          background="surface-4" 
          margin="false"
        >
          <div slot="header" className="menu-sidebar__header-container" style={{ width: `${headerWidth}px` }}>
            {logoSlot && <div className="menu-sidebar__logo-slot">{logoSlot}</div>}
            <div className="menu-sidebar__search-slot">{searchSelectorSlot}</div>
            <div className="menu-sidebar__data-collected">
              {dataCollectedSlot}
            </div>
          </div>

          <div slot="body" className="menu-sidebar__body">
            <div className="menu-sidebar__menu-slot">{menuSlot}</div>
          </div>
        </BdsSidebar>
      </BdsThemeProvider>
    </div>
  );
};
